@if (inProgress) {
<mat-progress-bar mode="indeterminate" color="primary" class="progress-bar" />
}
<header mat-dialog-title>
  @if (!secondaryMessage) {

  <mat-icon class="dialog-icon">{{ data.dialogIcon }}</mat-icon>
  @if (data.isCurrent) { Your }{{ data.entityLabel }} Details -
  {{ data.name }}@if (data.isOwner) { (Owner) } } @if (secondaryMessage) {

  <button mat-icon-button (click)="secondaryMessage = ''">
    <mat-icon class="dialog-icon">arrow_back</mat-icon>
  </button>
  Resend Invitation - {{ data.name }}

  }
</header>

<mat-dialog-content fxLayout="column">
  @if (data.description && !secondaryMessage) {
  <app-information-box>
    <div>{{ data.description }}</div>
    @if (data?.message) {
    <div fxLayout="row" class="message-quote">
      <mat-icon class="quote-icons flip-x" fxFlexAlign="start"
        >format_quote</mat-icon
      >
      <div>{{ data.message }}</div>
      <mat-icon class="quote-icons" fxFlexAlign="end">format_quote</mat-icon>
    </div>
    }
  </app-information-box>
  } @if (data.secondaryActivity?.buttonText === 'Resend') {
  <mat-form-field appearance="outline">
    <mat-label>Message</mat-label>
    <textarea
      matInput
      placeholder="Enter message"
      [(ngModel)]="secondaryMessage"
    ></textarea>
  </mat-form-field>
  }
  <mat-form-field appearance="outline">
    <mat-label>Project Group</mat-label>
    <input matInput [ngModel]="isAdminGroupAssigned" class="remove" />
    <mat-radio-group
      class="alignGrpOptions"
      [ngModel]="isAdminGroupAssigned"
      #projectGroupRadioGroup="matRadioGroup"
    >
      <mat-radio-button [value]="true">Administrator</mat-radio-button>
      <mat-radio-button [value]="false">Reviewer</mat-radio-button>
    </mat-radio-group>
    @if (data.projectGroupHint) {
    <mat-hint>
      {{ data.projectGroupHint }}
    </mat-hint>
    }
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions
  fxLayout="row"
  fxLayoutAlign="end center"
  fxLayoutGap="10px"
>
  <button mat-button [mat-dialog-close]="false">
    {{ data.dismissButtonText | uppercase }}
  </button>
  @if (data.negativeActivity && !secondaryMessage) {
  <button
    mat-flat-button
    color="warn"
    (click)="
      action(
        data.negativeActivity,
        getNewProjectGroups(projectGroupRadioGroup.value)
      )
    "
  >
    {{ data.negativeActivity.buttonText | uppercase }}
  </button>
  } @if (data.primaryActivity && !secondaryMessage) {
  <button
    mat-raised-button
    color="primary"
    (click)="
      action(
        data.primaryActivity,
        getNewProjectGroups(projectGroupRadioGroup.value)
      )
    "
    [disabled]="
      !data.primaryActivity.independentOfProjectGroupChange &&
      (projectGroupRadioGroup.value === isAdminGroupAssigned || inProgress)
    "
  >
    {{ data.primaryActivity.buttonText | uppercase }}
  </button>
  } @if (data.secondaryActivity && secondaryMessage) {
  <button
    mat-raised-button
    color="primary"
    (click)="
      action(
        data.secondaryActivity,
        getNewProjectGroups(projectGroupRadioGroup.value),
        secondaryMessage
      )
    "
  >
    {{ data.secondaryActivity.buttonText | uppercase }}
  </button>
  }
</mat-dialog-actions>
